export default function(code, isCollectCheck) {
  let msg;
  let isCollect = true;
  switch (code) {
    case '-1':
    case '400':
    case '404':
      msg = 'error.serverError';
      break;
    case '403':
      msg = 'error.forbidden';
      break;
    case '429':
      msg = 'error.tooManyReq';
      break;
    // case '1000':
    //   msg = 'error.notTradeWithSelf';
    //   break;
    // case '1001':
    //   msg = 'error.notSend';
    //   break;
    // case '1002':
    //   msg = 'error.notSign';
    //   break;
    // case '1003':
    //   msg = 'error.notUnsign';
    //   break;
    // case '1004':
    //   msg = 'error.notWithdraw';
    //   break;
    // case '1005':
    //   msg = 'error.insufficientBalance';
    //   break;
    // case '1008':
    //   msg = 'error.tokenMiss';
    //   break;
    // case '1009':
    //   msg = 'error.tradeOver';
    //   break;
    // case '1010':
    //   msg = 'error.inSigning';
    //   break;
    // case '1011':
    //   msg = 'error.notRepeat';
    //   break;
    // case '1012':
    //   msg = 'error.notEscrowed';
    //   break;
    // case '1013':
    //   msg = 'error.notRelease';
    //   break;
    // case '1014':
    //   msg = 'error.permissionDenied';
    //   break;
    // case '1015':
    //   msg = 'error.needCancelSignature';
    //   break;
    // case '1016':
    //   msg = 'error.needCancelEscrow';
    //   break;
    // case '1017':
    //   msg = 'error.notCancel';
    //   break;
    // case '1018':
    //   msg = 'error.abnormalStatus';
    //   break;
    // case '1019':
    //   msg = 'error.isCanceled';
    //   break;
    // case '1020':
    //   msg = 'error.delistBeforeEdit';
    //   break;
    // case '1021':
    //   msg = 'error.delistBeforeDelete';
    //   break;
    // case '1022':
    //   msg = 'error.isDelisted';
    //   break;
    // case '1023':
    //   msg = 'error.sellerIsNotEnough';
    //   break;
    // case '1024':
    //   msg = 'error.notCheckCounterpartyAssets';
    //   break;
    // case '1025':
    //   msg = 'error.buyerIsNotEnough';
    //   break;
    // case '1026':
    //   msg = 'error.refundFailed';
    //   break;
    // case '1027':
    //   msg = 'error.uncompeletedTrade';
    //   break;
    // case '1030':
    //   msg = 'error.onlyKyc';
    //   break;
    // case '1031':
    // msg = 'error.unsupportedCrypto';
    // break;
    // case '1037':
    //   msg = 'error.notSatisfiable';
    //   break;
    // case '1043':
    //   msg = 'error.outOfAdLimit';
    //   break;
    // case '1044':
    //   msg = 'error.advVerify';
    //   break;
    // case '1045':
    //   msg = 'error.joinChatFailed';
    //   break;
    // case '1047':
    //   msg = 'error.postKyc';
    //   break;
    // case '1056':
    //   msg = 'error.onlyWhiteList';
    //   break;
    case '40000':
    case '40001':
      msg = 'error.jwtInvalid';
      break;
    case '40002':
    case '40003':
    case '40004':
      msg = 'error.jwtExpired';
      isCollect = false;
      break;
    case '40005':
      msg = 'error.loginDenied';
      break;
    default:
  }
  if (isCollectCheck) {
    return isCollect;
  }
  return msg;
}
